import Vue from 'vue';
import Router from 'vue-router';


import simpeg_jabatan from './components/simpeg/data_master/jabatan.vue';
import simpeg_golongan from './components/simpeg/data_master/golongan.vue';


import simpeg from './components/simpeg/home/home.vue';
import simpeg_anak from './components/simpeg/biodata/anak.vue';
import simpeg_biodata from './components/simpeg/biodata/biodata.vue';
import simpeg_cuti from './components/simpeg/biodata/cuti.vue';

import simpeg_riwayat_pengangkatan from './components/simpeg/biodata/kepangkatan_jabatan/riwayat_pengangkatan.vue';
import simpeg_riwayat_kepangkatan from './components/simpeg/biodata/kepangkatan_jabatan/riwayat_kepangkatan.vue';
import simpeg_riwayat_jabatan_fungsional from './components/simpeg/biodata/kepangkatan_jabatan/riwayat_jabatan_fungsional.vue';
import simpeg_riwayat_jabatan_struktural from './components/simpeg/biodata/kepangkatan_jabatan/riwayat_jabatan_struktural.vue';

import simpeg_organisasi from './components/simpeg/biodata/organisasi.vue';
import simpeg_pengalaman from './components/simpeg/biodata/pengalaman.vue';
import simpeg_penghargaan_tanda_jasa from './components/simpeg/biodata/penghargaan_tanda_jasa.vue';
import simpeg_suami_istri from './components/simpeg/biodata/suami_istri.vue';

import simpeg_pendidikan_formal from './components/simpeg/pendidikan/pendidikan_formal.vue';
import simpeg_pendidikan_non_formal from './components/simpeg/pendidikan/pendidikan_non_formal.vue';

import simpeg_diklat_fungsional from './components/simpeg/pendidikan/diklat_fungsional.vue';
import simpeg_diklat_struktural from './components/simpeg/pendidikan/diklat_struktural.vue';


import simpeg_data_anak from './components/simpeg/biodata/data_keluarga/data_anak.vue';
import simpeg_data_suami_istri from './components/simpeg/biodata/data_keluarga/data_suami_istri.vue';

import simpeg_karpeg from './components/simpeg/biodata/karpeg.vue';
import simpeg_skp from './components/simpeg/biodata/skp.vue';



// import './assets/css/kiken/kiken.css'

Vue.use(Router)



function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/dashboard');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/monev_login');
  }
}

var routes = [
    {
        path: '/simpeg',
        name: '/simpeg',
        component: simpeg,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_anak',
        name: '/simpeg_anak',
        component: simpeg_anak,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_biodata',
        name: '/simpeg_biodata',
        component: simpeg_biodata,
        beforeEnter: isLoggedIn,
    },

    {
        path: '/simpeg_cuti',
        name: '/simpeg_cuti',
        component: simpeg_cuti,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_riwayat_pengangkatan',
      name: '/simpeg_riwayat_pengangkatan',
      component: simpeg_riwayat_pengangkatan,
      beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_riwayat_kepangkatan',
        name: '/simpeg_riwayat_kepangkatan',
        component: simpeg_riwayat_kepangkatan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_riwayat_jabatan_fungsional',
        name: '/simpeg_riwayat_jabatan_fungsional',
        component: simpeg_riwayat_jabatan_fungsional,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_riwayat_jabatan_struktural',
      name: '/simpeg_riwayat_jabatan_struktural',
      component: simpeg_riwayat_jabatan_struktural,
      beforeEnter: isLoggedIn,
  },
    {
        path: '/simpeg_organisasi',
        name: '/simpeg_organisasi',
        component: simpeg_organisasi,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_pendidikan_formal',
        name: '/simpeg_pendidikan_formal',
        component: simpeg_pendidikan_formal,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_pendidikan_non_formal',
        name: '/simpeg_pendidikan_non_formal',
        component: simpeg_pendidikan_non_formal,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_pengalaman',
        name: '/simpeg_pengalaman',
        component: simpeg_pengalaman,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_penghargaan_tanda_jasa',
        name: '/simpeg_penghargaan_tanda_jasa',
        component: simpeg_penghargaan_tanda_jasa,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_suami_istri',
        name: '/simpeg_suami_istri',
        component: simpeg_suami_istri,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_diklat_fungsional',
      name: '/simpeg_diklat_fungsional',
      component: simpeg_diklat_fungsional,
      beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_diklat_struktural',
        name: '/simpeg_diklat_struktural',
        component: simpeg_diklat_struktural,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/simpeg_jabatan',
        name: '/simpeg_jabatan',
        component: simpeg_jabatan,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_golongan',
      name: '/simpeg_golongan',
      component: simpeg_golongan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_data_anak',
      name: '/simpeg_data_anak',
      component: simpeg_data_anak,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_data_suami_istri',
      name: '/simpeg_data_suami_istri',
      component: simpeg_data_suami_istri,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_karpeg',
      name: '/simpeg_karpeg',
      component: simpeg_karpeg,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/simpeg_skp',
      name: '/simpeg_skp',
      component: simpeg_skp,
      beforeEnter: isLoggedIn,
    },

  ]



export default routes